import styled from 'styled-components';

export const Title = styled.h1`
  font-size: 2.375rem;
  font-weight: bold;
  line-height: 3.125rem;
  color: #0B4683;
  text-transform: uppercase;
  text-align: center;
  margin: 1.25rem;

  @media only screen and (max-width: 768px) {
    font-size: 1.8rem;
  }
`;